module.exports = __webpack_public_path__ + "media/images/four_flashcards-e573348e.svg";